

import JdReferee from "@/models/jd-referee";
import {
    CAREER_PLANNING_OPEN,
    CHAT_CLOSE,
    CHAT_OPEN_AFTER_ORDER,
    CHAT_OPEN_AFTER_POST,
    CHAT_OPEN_ALWAYS,
    CV_REVIEW_OPEN, INTERVIEW_OPEN, ITV_CV_REVIEW_OPEN
} from "@/constants/service";
import {REFEREE_CHAT, REFEREE_CV_SELECT} from "@/constants/bus";

const LCR = 'left-center-right'
const LC = 'left-center'

export default {
    name: "JdRefereeItem",
    props: {
        referee: JdReferee,
        index: {
            type: Number,
            default: 0,
        },
        layout: {
            type: String,
            default: LCR,
            validator: function (value) {
                return [LCR, LC].includes(value)
            }
        }
    },
    computed: {
        isLCR() {
            return this.layout === LCR
        },
        hasChat() {
            const type = this.referee.serviceChatType
            return type === CHAT_OPEN_AFTER_POST
                || type === CHAT_OPEN_AFTER_ORDER
                || type === CHAT_OPEN_ALWAYS
        },
        chatText() {
            switch(this.referee.serviceChatType) {
                case CHAT_OPEN_AFTER_POST:
                    return "投递简历后可聊天"
                case CHAT_OPEN_AFTER_ORDER:
                    return "购买服务后可聊天"
                case CHAT_OPEN_ALWAYS:
                    return "现在就聊"
                case CHAT_CLOSE:
                    return "内推官没有开启聊天服务"
            }
        },
        otherServiceText() {
            return "简历投递后可去您的账号「求职&招聘」/「我要求职」/「投递查询」页面查看投递反馈，约聊面试"
        },
        otherServiceText2() {
            let services = ""
            if (this.referee.serviceCvReview === CV_REVIEW_OPEN
                || this.referee.serviceItvCvReview === ITV_CV_REVIEW_OPEN) {
                services += "「评判简历」写出更符合职位需求简历，扬长避短\n"
            }

            if (this.referee.serviceInterview === INTERVIEW_OPEN
                || this.referee.serviceItvCvReview === ITV_CV_REVIEW_OPEN) {
                services += "「模拟面试」让内推官了解推荐您，为您背书\n"
            }

            if (this.referee.serviceCareerPlanning === CAREER_PLANNING_OPEN) {
                services += "「职业规划」让内推官为您指点迷津，明确发展方向"
            }

            return services ? "还可以找TA：\n" + services : ""
        }
    },
    methods: {
        onCvSelect() {
            this.$bus.$emit(REFEREE_CV_SELECT,this.referee)
        },
        onChat() {
            this.$bus.$emit(REFEREE_CHAT,this.referee)
        }
    }
}
